import { render, staticRenderFns } from "./AssetImporter.vue?vue&type=template&id=5edb89f2"
import script from "./AssetImporter.vue?vue&type=script&lang=js"
export * from "./AssetImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports